import React from 'react';
import { combineClassNames } from 'lib/utility';

const CardContent = ({ className, children }) => (
  <div className={combineClassNames('box__content', className)}>
    {children}
  </div>
);

export default CardContent;
